exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#orders__elem .two__level__menu__second{left:168px}#orders__elem div[role=table]{border-radius:0;box-shadow:unset}.orders-details .header{width:100% !important}", ""]);

// exports
